export default "__VITE_ASSET__03773fa4__"